import { Icon, IconProps } from "../Icon";

const ErrorFilled = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 1.33337C7.86668 1.33337 1.33334 7.86671 1.33334 16C1.33334 24.1334 7.86668 30.6667 16 30.6667C24.1333 30.6667 30.6667 24.1334 30.6667 16C30.6667 7.86671 24.1333 1.33337 16 1.33337ZM21.7333 23.3334L8.66668 10.2667L10.2667 8.66671L23.3333 21.7334L21.7333 23.3334Z"
      fill="currentColor"
    />
  </Icon>
);

export default ErrorFilled;
